export default __webpack_public_path__ + "completed-hover.svg";